export const SET_MANUAL_FIELD_OVERRIDE = 'SET_MANUAL_FIELD_OVERRIDE';
export const RESTORE_MANUAL_FIELD_OVERRIDES = 'RESTORE_MANUAL_FIELD_OVERRIDES';
export const CLEAR_MANUAL_FIELD_OVERRIDES = 'CLEAR_MANUAL_FIELD_OVERRIDES';
export const HYDRATE_MANUAL_FIELD_OVERRIDES = 'HYDRATE_MANUAL_FIELD_OVERRIDES';
export const SET_AUTO_SELECT_CHECKED = 'SET_AUTO_SELECT_CHECKED';
export const SET_AUTO_SELECT_DEALER_DEFAULTS = 'SET_AUTO_SELECT_DEALER_DEFAULTS';
